import React, { PureComponent } from 'react';
import { Label, FormGroup, Col, Row } from 'reactstrap';
import { number, func } from 'prop-types';
import Select from '../../../../components/common/Select';
import { FMessage } from '../../../../hoc/IntlComponents';
import CustomControl from '../../../../components/CustomControl/CustomControl';

const propTypes = {
  method: number.isRequired,
  onPostbackMethodChange: func.isRequired,
};

const defaultProps = {
  method: 0,
};

const methods = [
  {
    value: 0,
    label: 'POST',
  },
  {
    value: 1,
    label: 'GET',
  }
];

class FlowPostbackMethod extends PureComponent {
  render() {
    const { method, onPostbackMethodChange } = this.props;

    return (
      <FormGroup row>
        <Label lg={2} for="postback-method">
          <FMessage id="postback.global.method" />
        </Label>
        <Col lg='10'>
          <Row className='flow-postback-method'>
            {methods.map(option => (
              <Col key={option.value} lg='2'>
                <CustomControl
                  key={option.value}
                  id={`postback-method-${option.value}`}
                  label={option.label}
                  className="custom-control-xs"
                  type='checkbox'
                  value={option.value}
                  checked={option.value === method}
                  onChange={() => onPostbackMethodChange({ method: option.value })}
                />
              </Col>))}
          </Row>
          {/* <Select
            id="postback-method"
            name="method"
            clearable={false}
            value={method}
            onChange={({ value }) => onPostbackMethodChange({ method: value })}
            options={methods}
            searchable={false}
          /> */}
        </Col>
      </FormGroup>
    );
  }
}

FlowPostbackMethod.propTypes = propTypes;
FlowPostbackMethod.defaultProps = defaultProps;

export default FlowPostbackMethod;
